import '../scss/main.scss';
import $ from 'jquery';
// import { createApp } from 'vue';
// import { createPinia } from 'pinia';
// import { useRouter } from './route';
import App from '../vue/App.vue';
// @ts-ignore
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';

// Vue.js
// createApp(App).use(createPinia()).use(useRouter).mount('#app');

// Swiper
new Swiper('.js-slide-fade', {
  loop: true,
  speed: 1000,
  autoplay: {
    delay: 3000
  },
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  }
});

// jQuery
$(function () {
  // header effect
  function headerEffect() {
    if ($('body').hasClass('page-home-body')) {
      if (window.scrollY <= 100) {
        $('.js-header').addClass('__transparent');
        $('.js-header-inner').css('height', '85px');
        $('.js-header-logo').css('scale', '1');
      } else {
        $('.js-header').removeClass('__transparent');
        $('.js-header-inner').css('height', '65px');
        $('.js-header-logo').css('scale', '0.8');
      }
    } else {
      if (window.matchMedia('(max-width: 768px)').matches) {
        if (window.scrollY <= 100) {
          $('.js-header').addClass('__transparent');
          $('.js-header-inner').css('height', '85px');
          $('.js-header-logo').css('scale', '1');
        } else {
          $('.js-header').removeClass('__transparent');
          $('.js-header-inner').css('height', '65px');
          $('.js-header-logo').css('scale', '0.8');
        }
      } else {
        if (window.scrollY <= 100) {
          $('.js-header').removeClass('__transparent');
          $('.js-header-inner').css('height', '85px');
          $('.js-header-logo').css('scale', '1');
        } else {
          $('.js-header').removeClass('__transparent');
          $('.js-header-inner').css('height', '65px');
          $('.js-header-logo').css('scale', '0.8');
        }
      }
    }
  }
  headerEffect();
  $(window).on('scroll resize', function () {
    headerEffect();
  });

  // drawer navi
  $('.js-hamburger').on('click', function () {
    $('.js-drawer').fadeIn();
    $('.js-drawer').addClass('__shown-off-canvas');
  });
  $('.js-close').on('click', function () {
    $('.js-drawer').fadeOut();
    $('.js-drawer').removeClass('__shown-off-canvas');
  });
  $(window).on('scroll', function () {
    $('.js-drawer').fadeOut();
    $('.js-drawer').removeClass('__shown-off-canvas');
  });

  // gallery
  $('.js-gallery-thumbnail').on('click', function (): void {
    const targetSrc = $(this).find('img').attr('src') as string;
    $(this)
      .parent()
      .children()
      .each(function () {
        $(this).removeClass('__active');
      });
    $(this).parent().prev().find('.js-gallery-image').attr('src', targetSrc);
    $(this).addClass('__active');
  });
});
